import { render, staticRenderFns } from "./GradeChart.vue?vue&type=template&id=0e9034c2&"
import script from "./GradeChart.vue?vue&type=script&lang=js&"
export * from "./GradeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports